"use strict";

module.exports = require("./DurationHandler");